<template>
  <v-container class="aspirantes-enlace-container">
    <v-row>
      <v-col cols="12" lg="4" offset-lg="7">
        <v-text-field
          v-model="buscaPersonal"
          color="secondary"
          background-color="transparent"
          rounded
          outlined
          dense
          placeholder="Buscar personal por nombre, edad, municipio o estado..."
          append-icon="mdi-magnify"
          prepend-inner-icon="mdi-account-search"
          class="search-field-modern"
        ></v-text-field>
      </v-col>
      <v-col lg="1">
        <v-btn-toggle v-model="ordenAlfabetico" class="toggle-modern" rounded mandatory>
          <v-btn icon small>
            <v-icon color="secondary" size="20">mdi-order-alphabetical-ascending</v-icon>
          </v-btn>
          <v-btn icon small>
            <v-icon color="secondary" size="20">mdi-order-alphabetical-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaPersonal.length > 0">
        <div class="search-result-banner">
          <v-icon left color="secondary">mdi-information</v-icon>
          <span class="text-h6 font-weight-bold"> {{ filteredPersonal.length }} resultados encontrados </span>
          <span class="ml-2 text-subtitle-1">con la búsqueda "{{ buscaPersonal }}"</span>
        </div>
      </v-col>
      <v-expansion-panels flat class="expansion-panels-modern" focusable hover>
        <v-expansion-panel v-for="(grupoPersonal, index) in groupedPersonal" :key="index" class="panel-item-modern">
          <v-expansion-panel-header class="panel-header-modern">
            <div>
              <span class="text-h5 secondary--text font-weight-black d-inline">
                {{ grupoPersonal.inicial }}
              </span>
              <v-chip small color="secondary" class="ml-3" label>
                {{ grupoPersonal.personal.length }}
              </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content-modern">
            <v-container>
              <v-row>
                <v-col cols="12" lg="4" xl="3" v-for="personal in grupoPersonal.personal" :key="personal.id">
                  <div class="glass-card-aspirante">
                    <v-card class="transparent" elevation="0" height="100%">
                      <v-card-title class="card-title-aspirante">
                        <v-container>
                          <v-row>
                            <v-col cols="12" align="center">
                              <v-avatar
                                rounded
                                color="secondary"
                                size="90"
                                v-if="personal.foto.length == 0"
                                class="avatar-aspirante"
                              >
                                <v-icon x-large color="primary">mdi-account</v-icon>
                              </v-avatar>
                              <v-img
                                v-else
                                :src="personal.foto"
                                max-height="90"
                                max-width="90"
                                class="avatar-image-aspirante"
                              ></v-img>
                            </v-col>
                            <v-col cols="12" align="center">
                              <div class="text-h6 secondary--text font-weight-bold">{{ personal.apaterno }}</div>
                              <div class="text-subtitle-1 white--text">
                                {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                              </div>
                            </v-col>
                            <v-col cols="12" align="center">
                              <v-chip small color="secondary" outlined>
                                <v-icon small left>mdi-badge-account</v-icon>
                                CUIP: {{ personal.CUIP }}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-title>
                      <v-card-text class="card-text-aspirante">
                        <v-container>
                          <v-row>
                            <v-col cols="12" align="center">
                              <div class="info-label-aspirante">Evaluación C3 vigente hasta</div>
                              <div
                                v-if="personal.examenC3Mes.length > 0 && personal.vigenciaAnio != 0"
                                class="info-value-aspirante"
                              >
                                <v-chip small color="warning" dark class="mt-1">
                                  <v-icon x-small left>mdi-calendar-clock</v-icon>
                                  {{ personal.examenC3Mes }} del {{ personal.vigenciaAnio }}
                                </v-chip>
                              </div>
                              <div v-else class="info-value-empty-aspirante">Información no registrada</div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="card-actions-aspirante">
                        <v-container>
                          <v-row>
                            <v-col cols="12" align="right">
                              <v-tooltip
                                bottom
                                color="rgba(30, 30, 30, 0.95)"
                                v-if="hasAccessToFeature(perfil, FEATURES.REGISTRO_RESULTADOS_C3)"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="btn-icon-aspirante"
                                    elevation="4"
                                    icon
                                    v-on="on"
                                    v-bind="attrs"
                                    @click="openResultadoDialog(personal)"
                                  >
                                    <v-icon color="secondary">mdi-account-details</v-icon>
                                  </v-btn>
                                </template>
                                <span>Registro de resultados C3</span>
                              </v-tooltip>
                              <v-tooltip bottom color="rgba(30, 30, 30, 0.95)">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="btn-icon-aspirante mx-2"
                                    elevation="4"
                                    :to="{
                                      path: 'documentos_personal/' + personal.idPersonal,
                                      params: { id: personal.idPersonal },
                                    }"
                                    icon
                                    v-on="on"
                                    v-bind="attrs"
                                  >
                                    <v-icon color="secondary">mdi-file-account</v-icon>
                                  </v-btn>
                                </template>
                                <span>Ver expediente</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-actions>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <registro-resultados-aspirante-dialog-component
      :active="resultadosDialog"
      :personal="selectedPersonal"
      @close="resultadosDialog = false"
    ></registro-resultados-aspirante-dialog-component>
  </v-container>
</template>
<style scoped>
/* ===========================
   ASPIRANTES ENLACE C3 - ESTILOS MODERNOS
   =========================== */
.aspirantes-enlace-container {
  background: transparent;
}

/* Campo de búsqueda moderno */
.search-field-modern ::v-deep .v-input__slot {
  background: rgba(46, 38, 22, 0.5) !important;
  border: 1px solid rgba(247, 183, 49, 0.2) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
  padding: 4px 16px !important;
}

.search-field-modern ::v-deep .v-input__slot:hover {
  border-color: rgba(247, 183, 49, 0.4) !important;
  background: rgba(46, 38, 22, 0.7) !important;
}

.search-field-modern ::v-deep.v-input--is-focused .v-input__slot {
  border-color: #f7b731 !important;
  box-shadow: 0 0 0 3px rgba(247, 183, 49, 0.15) !important;
  background: rgba(46, 38, 22, 0.8) !important;
}

.search-field-modern ::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

.search-field-modern ::v-deep .v-text-field__slot input::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

.search-field-modern ::v-deep .v-icon {
  color: rgba(247, 183, 49, 0.7) !important;
}

.search-field-modern ::v-deep.v-input--is-focused .v-icon {
  color: #f7b731 !important;
}

/* Toggle moderno */
.toggle-modern {
  background: rgba(46, 38, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 183, 49, 0.2);
  border-radius: 12px;
  overflow: hidden;
}

.toggle-modern ::v-deep .v-btn {
  background: transparent !important;
  border: none !important;
  transition: all 0.3s ease;
}

.toggle-modern ::v-deep .v-btn--active {
  background: rgba(247, 183, 49, 0.2) !important;
}

.toggle-modern ::v-deep .v-btn:hover {
  background: rgba(247, 183, 49, 0.1) !important;
}

/* Banner de resultados */
.search-result-banner {
  background: rgba(46, 38, 22, 0.6);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(247, 183, 49, 0.2);
  border-radius: 16px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  animation: slideInDown 0.4s ease-out;
}

.search-result-banner .text-h6 {
  color: #f7b731 !important;
}

.search-result-banner .text-subtitle-1 {
  color: rgba(255, 255, 255, 0.7) !important;
}

/* Expansion panels modernos */
.expansion-panels-modern {
  background: transparent !important;
}

.panel-item-modern {
  background: rgba(46, 38, 22, 0.6) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(247, 183, 49, 0.15);
  border-radius: 16px !important;
  margin-bottom: 16px !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

.panel-item-modern:hover {
  border-color: rgba(247, 183, 49, 0.3);
  box-shadow: 0 8px 32px rgba(247, 183, 49, 0.15);
}

.panel-item-modern::before {
  box-shadow: none !important;
}

.panel-header-modern {
  background: rgba(247, 183, 49, 0.05) !important;
  border-bottom: 1px solid rgba(247, 183, 49, 0.1);
  padding: 20px 24px !important;
  transition: all 0.3s ease;
}

.panel-header-modern:hover {
  background: rgba(247, 183, 49, 0.1) !important;
}

.panel-header-modern ::v-deep .v-icon {
  color: #f7b731 !important;
}

.panel-content-modern {
  background: transparent !important;
  padding: 24px 16px !important;
}

/* Glass card aspirante */
.glass-card-aspirante {
  background: rgba(30, 30, 30, 0.5) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(247, 183, 49, 0.15);
  border-radius: 20px;
  padding: 4px;
  height: 100%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  animation: fadeInUp 0.6s ease-out;
}

.glass-card-aspirante:hover {
  border-color: rgba(247, 183, 49, 0.4);
  box-shadow: 0 12px 40px rgba(247, 183, 49, 0.25);
  transform: translateY(-6px);
}

/* Card titles y contenido */
.card-title-aspirante {
  padding: 24px 16px 16px 16px !important;
  border-bottom: 1px solid rgba(247, 183, 49, 0.1);
}

.card-text-aspirante {
  padding: 16px !important;
}

.card-actions-aspirante {
  background: rgba(247, 183, 49, 0.05) !important;
  border-top: 1px solid rgba(247, 183, 49, 0.1);
  padding: 12px 16px !important;
}

/* Avatar aspirante */
.avatar-aspirante {
  background: rgba(247, 183, 49, 0.15) !important;
  border: 3px solid rgba(247, 183, 49, 0.3);
  transition: all 0.4s ease;
}

.glass-card-aspirante:hover .avatar-aspirante {
  transform: scale(1.1) rotate(3deg);
  border-color: #f7b731;
  box-shadow: 0 0 30px rgba(247, 183, 49, 0.5);
}

.avatar-image-aspirante {
  border-radius: 12px !important;
  border: 3px solid rgba(247, 183, 49, 0.3);
  transition: all 0.4s ease;
}

.glass-card-aspirante:hover .avatar-image-aspirante {
  transform: scale(1.1);
  border-color: #f7b731;
  box-shadow: 0 0 30px rgba(247, 183, 49, 0.5);
}

/* Info labels */
.info-label-aspirante {
  color: rgba(255, 255, 255, 0.5) !important;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.info-value-aspirante {
  color: #e0e0e0 !important;
  font-size: 0.875rem;
  font-weight: 500;
}

.info-value-empty-aspirante {
  color: rgba(255, 255, 255, 0.3) !important;
  font-size: 0.875rem;
  font-style: italic;
}

/* Botones de icono */
.btn-icon-aspirante {
  background: rgba(247, 183, 49, 0.12) !important;
  border: 1px solid rgba(247, 183, 49, 0.2);
  transition: all 0.3s ease;
}

.btn-icon-aspirante:hover {
  background: rgba(247, 183, 49, 0.25) !important;
  border-color: #f7b731;
  transform: scale(1.15) rotate(5deg);
  box-shadow: 0 4px 16px rgba(247, 183, 49, 0.4);
}

/* Colores de texto */
.secondary--text {
  color: #f7b731 !important;
}

.white--text {
  color: #e0e0e0 !important;
}

/* Chips */
::v-deep .v-chip.secondary {
  background: rgba(247, 183, 49, 0.15) !important;
  border-color: rgba(247, 183, 49, 0.4) !important;
  color: #f7b731 !important;
  font-weight: 600;
}

::v-deep .v-chip.warning {
  background: rgba(255, 159, 67, 0.15) !important;
  border: 1px solid rgba(255, 159, 67, 0.3);
  color: #ff9f43 !important;
  font-weight: 600;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 30, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 183, 49, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(247, 183, 49, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(247, 183, 49, 0.6);
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 1264px) {
  .glass-card-aspirante {
    margin-bottom: 20px;
  }

  .panel-item-modern {
    margin-bottom: 12px !important;
  }
}

@media (max-width: 960px) {
  .card-title-aspirante {
    padding: 16px !important;
  }

  .avatar-aspirante,
  .avatar-image-aspirante {
    width: 70px !important;
    height: 70px !important;
  }

  .search-result-banner {
    flex-direction: column;
    text-align: center;
  }
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import ValidacionAsuntosInternosDialogComponent from '../../components/enlace/ValidacionAsuntosInternosDialogComponent.vue'
import MarcaActivoDialogComponent from '../../components/enlace/MarcaActivoDialogComponent.vue'
import RegistroResultadosAspiranteDialogComponent from '../../components/enlace/RegistroResultadosAspiranteDialogComponent'

export default {
  components: {
    ValidacionAsuntosInternosDialogComponent,
    MarcaActivoDialogComponent,
    RegistroResultadosAspiranteDialogComponent,
  },

  data() {
    return {
      buscaPersonal: '',
      ordenAlfabetico: 0,
      asuntosInternosDialog: false,

      selectedPersonal: null,
      marcaActivoDialog: false,

      resultadosDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('preaspirante', {
      personal: 'getAspirantes',
    }),

    filteredPersonal: function () {
      return this.personal
        .filter((personal) => {
          return (
            this.getFullName(personal).toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0 ||
            personal.rfc.toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0 ||
            personal.curp.toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0
          )
        })
        .filter((personal) => {
          return personal.CUIP !== ''
        })
    },

    groupedPersonal: function () {
      var result = _(this.filteredPersonal)
        .groupBy((personal) => personal.apaterno[0].toUpperCase())
        .map((personal, inicial) => ({ inicial, personal }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },

  methods: {
    openAsuntosInternosDialog(personal) {
      this.selectedPersonal = personal.idPersonal
      this.asuntosInternosDialog = true
    },

    openMarcaActivoDialog(personal) {
      this.selectedPersonal = personal.idPersonal
      this.marcaActivoDialog = true
    },

    openResultadoDialog(personal) {
      this.selectedPersonal = personal
      this.resultadosDialog = true
    },
  },
}
</script>
